import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

/**
 * Gets the data for ManagePaidAmounts screen.
 * @param {number} campaignId
 */
export default async ({ campaignId }) => {
  const query = `query 
  ($campaignId:ID!) {
      campaign(id:$campaignId){
        country{
          currencySign
        }
        cityPlans {
          nodes {
            id
            city {
              id
              name
            }
          }
        }
      }
    }`

  return await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/ManagePaidAmounts/gql.js